import { Component } from '@angular/core';
import { HeroEmpresarialComponent } from '../hero-empresarial/hero-empresarial.component';
import {HeroMedicoDispensarioComponent} from "./hero-medico-dispensario/hero-medico-dispensario.component";
import {InfoComponent} from "../home/info/info.component";
import {DecretoComponent} from "./decreto/decreto.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-medico-dispensario',
  standalone: true,
    imports: [
        HeroEmpresarialComponent,
        HeroMedicoDispensarioComponent,
        InfoComponent,
        DecretoComponent,
        FooterPersonaComponent
    ],
  templateUrl: './medico-dispensario.component.html',
  styleUrl: './medico-dispensario.component.css'
})
export class MedicoDispensarioComponent {





}
